export const navigationTranslations = {
  en: {
    home: 'HOME',
    about: 'ABOUT',
    products: 'PRODUCTS',
    consulting: 'CONSULTING',
    community: 'COMMUNITY'
  },
  de: {
    home: 'HOME',
    about: 'ÜBER UNS',
    products: 'PRODUKTE',
    consulting: 'BERATUNG',
    community: 'COMMUNITY'
  }
}; 